import { getPropertyTypeTemplatesState } from './property-type-templates.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchPropertyTypeTemplatesRequest,
  DeletePropertyTypeTemplateRequest,
} from './property-type-templates.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-property-type-templates',
  templateUrl: './property-type-templates.component.html',
  styleUrls: ['./property-type-templates.component.css'],
})
export class PropertyTypeTemplatesComponent
  extends ListTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public columns: object[] = [
    {
      prop: 'propertyType',
      name: 'PROPERTY_TYPE',
    },
    {
      prop: 'template',
      name: 'TEMPLATE',
      render: (column: Map<string, any>) => column && column.get('name'),
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getPropertyTypeTemplatesState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          this.shouldReload !== state.get('shouldReload') &&
          state.get('shouldReload')
        ) {
          this.shouldReload = state.get('shouldReload')
          this.store.dispatch<any>(new FetchPropertyTypeTemplatesRequest())
        }
      })
    // this.store.dispatch<any>(new FetchPropertyTypeTemplatesRequest())
    this.runFilter()
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  runFilter(data?: any) {
    const pagination = data?.pagination ?? this.state.get('pagination').toJS()
    const { page, page_size, sort, order_by } = pagination

    this.store.dispatch<any>(
      new FetchPropertyTypeTemplatesRequest({
        filters: {},
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('pagination', pagination, 'list'))
  }

  onPageChange(page: any) {
    const pagination = this.state.get('pagination').toJS()
    const { page_size, sort, order_by } = pagination

    this.store.dispatch<any>(
      new FetchPropertyTypeTemplatesRequest({
        filters: {},
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )

    this.store.dispatch(
      new UpdateField('pagination', { ...pagination, page }, 'list'),
    )
  }
  onPageSizeChange(page_size: any) {
    const pagination = this.state.get('pagination').toJS()
    const { page, sort, order_by } = pagination

    this.store.dispatch<any>(
      new FetchPropertyTypeTemplatesRequest({
        filters: {},
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )

    this.store.dispatch(
      new UpdateField('pagination', { ...pagination, page_size }, 'list'),
    )
  }

  public deleteTemplate(id: number) {
    this.store.dispatch(new DeletePropertyTypeTemplateRequest(id))
  }
}
